// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import { Switch} from "antd";

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";

// Import utils
import {
    changeStateField,
    getInputValues,
    getPatchReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
} from "../../utils/helperFunctions";
import {mapStateToProps} from "../../redux/mapStateToProps";
import {CreateBank, UpdateBankById} from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";


class AddEditBank extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                percent: 0,
                monthsCount: 0,
                advancePayment: 0,
                isHidden: false,
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            requestLoading: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.addEditBank = this.addEditBank.bind(this);
    }

    async componentDidMount() {
        const {isEditing} = this.state;
        const translationsData = {};

        if (isEditing) {
            const editingData = this.props?.banksList?.find(type => type.id === this.props.id);
            if (editingData) {
                editingData.translations.forEach(item => {
                    translationsData[item.language] = {
                        ...translationsData[item.language],
                        title: item.title || '',
                    };
                });
            }
            const initStateData = {
                translations: translationsData,
                percent: editingData?.percent,
                monthsCount: editingData?.monthsCount,
                advancePayment: editingData?.advancePayment,
                isHidden: editingData?.isHidden,
            };
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                ...this.state,
                fieldsData: initStateData
            });

        }
    }

    addEditBank() {
        this.setState({
            requestLoading: true
        });
        const {fieldsData} = this.state;
        const {translations, isHidden, percent} = fieldsData;
        const translationRequiredFields = ['title']
        const requiredFields = ['percent', "monthsCount"]
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = {...validationTr.errors};
        requiredFields.forEach(field => {
            if (!fieldsData[field] ) {
                errors[field] = true
                result = false
            }
        })
        if (result) {
            const trData = getTranslationData(translations)
            if (!this.state.isEditing) {
                const reqData = {
                    isHidden,
                    percent,
                    translations: trData,
                };
                fieldsData.monthsCount && (reqData.monthsCount = fieldsData?.monthsCount);
                fieldsData.advancePayment && (reqData.advancePayment = fieldsData?.advancePayment);
                this.props.CreateBank(reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    })
            } else {
                const reqData = this.getPatchReqData(trData);
                reqData.monthsCount = fieldsData?.monthsCount || 0
                reqData.advancePayment = fieldsData?.advancePayment  || 0
                this.props.UpdateBankById(this.props.id, reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    });
            }

        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render() {
        const {fieldsData, errors, languageTab, requestLoading, isEditing, errorsTabs} = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};


        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել սենյակի տեսակ' : 'Փոփոխել սենյակի տեսակը'}>
            <section className="general-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: "isHidden",
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            required={true}
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            onChange={this.getTranslationValues}/>
                <InputGroup value={fieldsData?.percent}
                            label={"Տոկոս"}
                            placeholder="Տոկոս"
                            inputType={"input"}
                            type={'number'}
                            name={"percent"}
                            minValue={0}
                            required={true}
                            initValue={this.currentData?.percent}
                            error={errors.percent}
                            onChange={this.getInputValues}/>
                <InputGroup value={fieldsData?.monthsCount}
                            label={"Ժամկետ"}
                            placeholder="Ժամկետ"
                            inputType={"input"}
                            type={'number'}
                            name={"monthsCount"}
                            integerNumber={true}
                            minValue={0}
                            required={true}
                            initValue={this.currentData?.monthsCount}
                            error={errors.monthsCount}
                            onChange={this.getInputValues}/>
                <InputGroup value={fieldsData?.advancePayment}
                            label={"Կանխավճար (%)"}
                            placeholder="Կանխավճար (%)"
                            inputType={"input"}
                            type={'number'}
                            name={"advancePayment"}
                            minValue={0}
                            required={false}
                            monthsCount
                            initValue={this.currentData?.advancePayment}
                            onChange={this.getInputValues}/>

                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                disabled={isEditing && !this.updatedDataMap.size}
                                cb={this.addEditBank}/>
                </div>
            </section>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    CreateBank,
    UpdateBankById
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditBank)
